export default {"src":"/_next/static/media/leftArrow.06faef91.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};